interface StoredQueryData<TData> {
  cachedAt: number;
  data: TData;
}

function storageAvailable() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function readStoredQueryData<TData>(
  key: string,
  maxAgeMs: number,
): StoredQueryData<TData> | null {
  if (!storageAvailable()) return null;

  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<StoredQueryData<TData>>;
    if (typeof parsed.cachedAt !== "number" || !("data" in parsed)) {
      window.sessionStorage.removeItem(key);
      return null;
    }

    if (Date.now() - parsed.cachedAt > maxAgeMs) {
      window.sessionStorage.removeItem(key);
      return null;
    }

    return parsed as StoredQueryData<TData>;
  } catch {
    window.sessionStorage.removeItem(key);
    return null;
  }
}

export function writeStoredQueryData<TData>(key: string, data: TData): void {
  if (!storageAvailable()) return;

  try {
    window.sessionStorage.setItem(key, JSON.stringify({ cachedAt: Date.now(), data }));
  } catch {
    // Storage quota or privacy-mode failures should not affect app behavior.
  }
}
